"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FactoryOffCanvas = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var type_guard_1 = require("@webnuts/type-guard");
var react_1 = require("react");
// eslint-disable-next-line no-restricted-imports
var styled_components_1 = __importStar(require("styled-components"));
var css_types_1 = require("../../internal/css-types");
var factory_1 = require("../../internal/factory");
var factory_utils_1 = require("../../internal/factory-utils");
var direction = type_guard_1.union([
    type_guard_1.literal('left'),
    type_guard_1.literal('left-bottom'),
    type_guard_1.literal('right'),
    type_guard_1.literal('right-bottom'),
    type_guard_1.literal('top'),
    type_guard_1.literal('top-right'),
    type_guard_1.literal('bottom'),
    type_guard_1.literal('bottom-right')
]);
var SETTINGS = {
    direction: type_guard_1.optional(direction),
    asideWidth: type_guard_1.optional(css_types_1.width)
};
exports.FactoryOffCanvas = factory_1.factory({
    prefix: 'OffCanvas',
    settings: __assign(__assign({}, SETTINGS), { direction: direction, childrenZindex: type_guard_1.optional(type_guard_1.number()), asideZindex: type_guard_1.optional(type_guard_1.number()), breakpoints: factory_utils_1.makeBreakpointSettings(SETTINGS) }),
    component: function (settings, utils) {
        var Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      position: relative;\n      display: inline-block;\n    "], ["\n      position: relative;\n      display: inline-block;\n    "])));
        Container.displayName = 'OffCanvas.Container';
        var Aside = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      position: absolute;\n      transition: top 0.1s ease-out, left 0.1s ease-out, bottom 0.1s ease-out, right 0.1s ease-out,\n        opacity 0.1s ease-out, transform 0.1s ease-out;\n      ", "\n      ", "\n    "], ["\n      position: absolute;\n      transition: top 0.1s ease-out, left 0.1s ease-out, bottom 0.1s ease-out, right 0.1s ease-out,\n        opacity 0.1s ease-out, transform 0.1s ease-out;\n      ", "\n      ", "\n    "])), function (_a) {
            var $open = _a.$open, asideZindex = _a.$settings.asideZindex;
            return styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        ", "\n        ", "\n        ", "\n        ", "\n      "], ["\n        ", "\n        ", "\n        ", "\n        ", "\n      "])), utils.css.rule('z-index', $open ? asideZindex !== null && asideZindex !== void 0 ? asideZindex : '1' : '-1'), utils.css.rule('overflow', $open ? undefined : 'hidden'), utils.css.rule('opacity', $open ? 1 : 0), utils.css.rule('pointer-events', $open ? undefined : 'none'));
        }, function (_a) {
            var $settings = _a.$settings, $open = _a.$open;
            return utils.css.breakpoint($settings.breakpoints, $settings, function (_a) {
                var direction = _a.direction, asideWidth = _a.asideWidth;
                var dir = direction !== null && direction !== void 0 ? direction : $settings.direction;
                // TODO: Add collision detection later, perhaps using popper or similar.
                return styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n            ", ";\n            ", "\n            ", "\n            ", "\n            ", "\n          "], ["\n            ", ";\n            ", "\n            ", "\n            ", "\n            ", "\n          "])), utils.css.rule('top', dir.startsWith('top') || dir.endsWith('-bottom')
                    ? undefined
                    : $open && dir.startsWith('bottom')
                        ? '100%'
                        : '0'), utils.css.rule('bottom', dir.endsWith('-bottom') ? '0' : dir.startsWith('top') ? ($open ? '100%' : '0') : undefined), utils.css.rule('left', dir.startsWith('left') || dir.endsWith('-right')
                    ? undefined
                    : $open && dir.startsWith('right')
                        ? '100%'
                        : '0'), utils.css.rule('right', dir.endsWith('-right') ? '0' : dir.startsWith('left') ? ($open ? '100%' : '0') : undefined), utils.css.width(asideWidth));
            });
        });
        Aside.displayName = 'OffCanvas.Aside';
        var ChildrenWrapper = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      position: relative;\n      z-index: ", ";\n    "], ["\n      position: relative;\n      z-index: ", ";\n    "])), function (_a) {
            var $zIndex = _a.$zIndex;
            return $zIndex !== null && $zIndex !== void 0 ? $zIndex : 2;
        });
        ChildrenWrapper.displayName = 'OffCanvas.ChildrenWrapper';
        return react_1.forwardRef(function (_a, ref) {
            var open = _a.open, children = _a.children, props = __rest(_a, ["open", "children"]);
            var _b = __read(react_1.Children.toArray(children)), firstChild = _b[0], rest = _b.slice(1);
            return (jsx_runtime_1.jsxs(Container, __assign({ ref: ref }, props, { children: [jsx_runtime_1.jsx(Aside, __assign({ "$open": open, "$settings": settings }, { children: firstChild }), void 0), jsx_runtime_1.jsx(ChildrenWrapper, __assign({ "$zIndex": settings.childrenZindex }, { children: rest }), void 0)] }), void 0));
        });
    }
}).FactoryOffCanvas;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
